import React, { Component } from 'react'

export class Warning extends Component {
	render() {
		return (
			<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_1649_921)">
					<path fillRule="evenodd" clipRule="evenodd" d="M62.9689 17.7067L46.3289 1.06667C45.6533
					0.391111 44.7289 0 43.8044 0H20.1956C19.2711 0 18.3467 0.391111 17.7067 1.03111L1.03111
					17.7067C0.391111 18.3467 0 19.2711 0 20.1956V43.7689C0 44.7289 0.391111 45.6178 1.03111
					46.2933L17.6711 62.9333C18.3467 63.6089 19.2711 64 20.1956 64H43.7689C44.7289 64 45.6178
					63.6089 46.2933 62.9689L62.9333 46.3289C63.2645 45.9978 63.5262 45.604 63.7033 45.1706C63.8803
					44.7371 63.9691 44.2727 63.9644 43.8044V20.1956C64 19.2711 63.6089 18.3467 62.9689 17.7067ZM56.8889
					42.3111L42.3111 56.8889H21.6889L7.11111 42.3111V21.6889L21.6889 7.11111H42.3111L56.8889 21.6889V42.3111ZM32.0001
					49.7778C33.9637 49.7778 35.5556 48.1859 35.5556 46.2222C35.5556 44.2585 33.9637 42.6667 32.0001
					42.6667C30.0364 42.6667 28.4445 44.2585 28.4445 46.2222C28.4445 48.1859 30.0364 49.7778 32.0001
					49.7778ZM28.4445 17.7779C28.4445 15.8223 30.0445 14.2223 32.0001 14.2223C33.9556 14.2223 35.5556
					15.8223 35.5556 17.7779V35.5557C35.5556 37.5112 33.9556 39.1112 32.0001 39.1112C30.0445 39.1112
					28.4445 37.5112 28.4445 35.5557V17.7779Z" fill="#DC3545" />
				</g>
				<defs>
					<clipPath id="clip0_1649_921">
						<rect width="64" height="64" fill="white" />
					</clipPath>
				</defs>
			</svg>

		)
	}
}

export default Warning
